import React from 'react';
import { MdNightlightRound, MdSunny } from "react-icons/md";

const ModeSwitcher = ({ eye_mode, changeMode }) => {

    if (!eye_mode) {
        return "";
    }

    let button = ''

    if(eye_mode == 'dark-mode'){
        button = <button type="button" onClick={(e) => changeMode(e, 'light-mode')} className='text-orange text-decoration-none d-flex align-items-center mode-switch' href='#'><MdSunny /></button>
    }
    else{
        button = <button type="button" onClick={(e) => changeMode(e, 'dark-mode')} className='text-orange text-decoration-none d-flex align-items-center mode-switch' href='#'><MdNightlightRound /></button>
    }

    return button
}

export default ModeSwitcher;